import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { RootState } from 'store/ducks';
import store from 'store';
import queryString from 'query-string';

import TabNavigation from 'components/TabNavigation';
import { Row, Column } from 'components/Layout/Grid';
import Text from 'components/Text';
import { MenuItems } from 'components/MenuItems';
import SwitchComponent from 'components/SwitchComponent';
import MenuSac from 'components/MenuSac';
import OrdersTable from 'components/Table/Orders';
import {
  ordersModelDash,
  ordersModelDashPending,
  ordersModelDashButtonShipping
} from 'components/Table/Orders/models';
import QuotesTable from 'components/Table/Quotes';
import { quotesModelDash } from 'components/Table/Quotes/models';
import OrderDropdown from 'components/OrderDropdown';
import { ticketsModelBasic } from 'components/Table/Tickets/models';
import TicketsTable from 'components/Table/Tickets';
import { ITableModel } from 'components/Table/interface';
import { Button } from 'components/Button';
import {
  cotacoesAction,
  eventName,
  pedidosAction,
  protocolosAction
} from 'components/ApplicationInsights/eventNames';
import { ShippingCompany } from 'components/ShippingCompany';
import { GreenDelivery } from 'components/GreenDelivery';
import SliderMessage from 'components/SliderMessage';
import { Visibility } from 'components/Visibility';
import toast from 'components/Toast/dispatch';
import { OrdersTabsEnum } from 'models/Order';

import TicketServices from 'services/ticket.service';
import DomainSettingService from "services/domainSetting.service";
import KeycloakPubServiceInstance from 'services/keycloakpubsub.service';

import infoImg from 'img/icon-stock-not-available.svg';

import { ObjectIsEmpty } from 'utils/Object';

import './styles.scss';
import MenuItemsSupplier from 'components/MenuItemsSupplier';
import { Banner } from 'components/Banner';

export default function Dashboard() {

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state: RootState) => state.user);

  const [ordersFilter, setOrdersFilter] = useState();

  const [ticketsFilter, setTicketsFilter] = useState({
    statusType: { ne: 'DONE' }
  });

  const pageSize = 8;

  const [showRatingTicket, setShowRatingTicket] = useState(false);
  const [textRatingTicket, setTextRatingTicket] = useState('Registrando avaliação...');

  const _ticketService = new TicketServices();

  const _domainSettingService = new DomainSettingService();

  useEffect(() => {
    ratingTicket();
  }, []);

  useEffect(() => {
    if (!user?.notViewInitialModal && !ObjectIsEmpty(user))
      showInitialInfo();
  }, [user]);

  function showRankingMessage(time: number, msg: string) {
    if (msg) setTextRatingTicket(msg);

    if (time) {
      const idTimeout = setTimeout(() => {
        setShowRatingTicket(false);
        clearTimeout(idTimeout);
      }, time);
    }
  }

  const ratingTicket = async () => {
    KeycloakPubServiceInstance.subscribe(async () => {
      const params = queryString.parse(location.search);
      if (params.objectId && params.value !== '') {
        setShowRatingTicket(true);
        await _ticketService
          .rating({ objectId: params.objectId, value: params.value })
          .then(() => {
            showRankingMessage(5000, 'Agradecemos a sua avaliação');
          })
          .catch((e) => {
            showRankingMessage(
              5000,
              e?.response?.data?.data || 'Falha ao registrar a sua avaliação'
            );
          });
      }
    });
  };

  const [refreshTable, setRefreshTable] = useState(false);

  const editButtonLabel: ITableModel = {
    label: 'Protocolo',
    key: 'protocolNumber',
    size: 130,
    maxSize: 130,
    Component: (data: any) => (
      <Button
        className="px-0"
        onClick={() =>
          store.dispatch({
            type: 'OPEN_CARD',
            data: {
              id: data.cardId,
              protocolNumber: data.protocolNumber,
              responsibleGroup: data.responsibleGroup,
              ticketId: data.id,
              ticketDevolution: data.ticketDevolution || null,
              ticketCorrectionLetter: data.ticketCorrectionLetter || null,
              ticketReason: data.ticketReason,
              state: { setRefreshTable },
            },
          })
        }
        width="auto"
      >
        <Text className="color-blue-gray" size={12}>
          {data.protocolNumber}
        </Text>
      </Button>
    ),
  };

  const ticketModelEdit: Array<ITableModel> = [
    editButtonLabel,
    ...ticketsModelBasic,
  ];

  function actionInitialModal() {
    dispatch({ type: 'CLOSE_TOAST' });
    dispatch({
      type: 'SET_USER_NOT_VIEW_INITIAL_MODAL',
      value: true,
    });
    navigate('/abrir-protocolo');
  }

  async function showInitialInfo() {
    const result = await _domainSettingService.initialAlert();
    if (result && result.data) {
      const json = JSON.parse(result.data.value);
      if (!json?.userType || json.userType === user?.userType) {
        toast.yesNoCustom(
          json.title,
          json.message,
          () => actionInitialModal(),
          infoImg,
          98,
          json.leftButton,
          json.rightButton,
          json.eventName,
          json.trackAction,
          json.widthContainer,
          true,
          true
        );
      }
    }
  }

  return (
    <>
      <SliderMessage show={showRatingTicket} message={textRatingTicket} />
      <Row className="w-100 flex-lg-column">
        <Column className="w-100">
          <Row className="animated fadeIn" >
            <Banner />
          </Row>
          <Row
            className="px-2 flex-md-column mt-md-3 flex-1"
            style={{ marginTop: -45, zIndex: 1 }}
          >
            <SwitchComponent
              roles={['administrator', 'member']}
              type={['customer']}
            >
              <MenuItems />
            </SwitchComponent>
            <SwitchComponent
              roles={['administrator', 'member']}
              type={['employee']}
            >
              <MenuSac />
            </SwitchComponent>
            <SwitchComponent
              roles={['administrator', 'supplier']}
              type={['supplier']}
            >
              <MenuItemsSupplier />
            </SwitchComponent>
          </Row>
        </Column>
      </Row>

      <Visibility visible={false}>
        <ShippingCompany />
      </Visibility>

      <GreenDelivery />
      <SwitchComponent
        roles={['administrator', 'member']}
        type={['employee', 'customer']}
      >
        <Row className="w-100 flex-lg-column mt-6">
          <Column className="flex-1 w-lg-100 min-w-50 pr-2 pr-lg-0 w-50">
            <Text size={24} className="color-primary font-bold">
              Últimos Pedidos
            </Text>
            <TabNavigation
              trackingKey="Abas Pedidos"
              trackingEvent={eventName.PEDIDOS}
              className="mt-3"
              setTabFilter={(filter) => setOrdersFilter(filter)}
              tabLabels={[
                { label: 'Pedidos Faturados', trackingName: pedidosAction.ABA_DASHBOARD_PEDIDOSFATURADOS },
                { label: 'Pedidos Pendentes', trackingName: pedidosAction.ABA_DASHBOARD_PEDIDOSPENDENTES },
                { label: 'Venda Triangular', trackingName: pedidosAction.ABA_DASHBOARD_VENDATRIANGULAR },
                { label: 'Cotações', filter: {}, trackingName: cotacoesAction.ABA_DASHBOARD_COTACOES },
              ]}
              pages={[
                <OrdersTable
                  trackingKey="Pedidos Faturados"
                  key={1}
                  tabFilter={ordersFilter}
                  model={ordersModelDash}
                  pageSize={pageSize}
                  showButton
                  completeBlankSpaces
                  DropdownTemplate={(data: any) => (
                    <OrderDropdown {...data} order={data} />
                  )}
                  customProps={{
                    showItems: false,
                    showOrderDownloadButtons: false,
                  }}
                  currentTabId={{
                    name: OrdersTabsEnum.PEDIDO_FATURADO,
                    order: 0
                  }}
                />,
                <OrdersTable
                  trackingKey="Pedidos Pendentes"
                  key={2}
                  tabFilter={ordersFilter}
                  model={ordersModelDashPending}
                  pageSize={pageSize}
                  showButton
                  completeBlankSpaces
                  currentTabId={{
                    name: OrdersTabsEnum.PEDIDO_PENDENTE,
                    order: 1
                  }}
                />,
                <Column className="w-100 max-w-lg-100 flex-1" key={3}>
                  <OrdersTable
                    trackingKey="Venda Triangular"
                    key={3}
                    tabFilter={ordersFilter}
                    model={ordersModelDashButtonShipping}
                    pageSize={pageSize}
                    showButton
                    completeBlankSpaces
                    DropdownTemplate={(data: any) => (
                      <OrderDropdown {...data} order={data} />
                    )}
                    customProps={{
                      showItems: false,
                      showOrderDownloadButtons: false,
                    }}
                    showExportButton={false}
                    currentTabId={{
                      name: OrdersTabsEnum.VENDA_TRIANGULAR,
                      order: 2
                    }}
                  />
                </Column>,
                <QuotesTable
                  trackingKey="Cotações"
                  model={quotesModelDash}
                  pageSize={pageSize}
                  showButton
                  completeBlankSpaces
                  key={4}
                />,
              ]}
            />
          </Column>
          <Column className="flex-1 w-lg-100 min-w-50 mt-lg-5 pl-2 pl-lg-0 w-50">
            <Text size={24} className="color-primary font-bold">
              Protocolos
            </Text>
            <TabNavigation
              trackingKey="Abas Protocolos"
              trackingEvent={eventName.PROTOCOLOS}
              className="mt-3"
              setTabFilter={(filter) => setTicketsFilter(filter)}
              tabLabels={[
                { label: 'Abertos', filter: { statusType: { ne: 'DONE' } }, trackingName: protocolosAction.ABA_DASHBOARD_PROTOCOLOSABERTOS },
                { label: 'Fechados', filter: { statusType: { eq: 'DONE' } }, trackingName: protocolosAction.ABA_DASHBOARD_PROTOCOLOSFECHADOS },
              ]}
              pages={[
                <TicketsTable
                  trackingKey="Protocolos Abertos"
                  showButton
                  pageSize={pageSize}
                  model={ticketModelEdit}
                  tabFilter={ticketsFilter}
                  completeBlankSpaces
                  showProtocolsOnLoad
                  refreshTable={refreshTable}
                  isPageTickets={false}
                  statusTypes={[0, 1]}
                />,
                <TicketsTable
                  trackingKey="Protocolos Fechados"
                  showButton
                  pageSize={pageSize}
                  model={ticketModelEdit}
                  tabFilter={ticketsFilter}
                  completeBlankSpaces
                  showProtocolsOnLoad
                  refreshTable={refreshTable}
                  isPageTickets={false}
                  statusTypes={[2]}
                />,
              ]}
            />
          </Column>
        </Row>
      </SwitchComponent>

    </>
  );
}